export default __webpack_public_path__ + "static/media/perguntas.7e5a3dca.svg";